import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isBlockedEmailDomain } from '@core/utils';

export class CustomValidators {

  static noWhitespace(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && control.value.trim().length === 0) {
        return { whitespace: true };
      }
      return null;
    };
  }

  static blacklistEmail(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      const { isBlocked, domainName } = isBlockedEmailDomain(value);

      if (isBlocked) {
        return { blockedDomain: { value: domainName } };
      }

      return null;
    };
  }
}
